import React from 'react';
import { getEndAndStartDate } from 'utilities/date/date';
import { SiteName } from 'types/Site';
import BrandTypes from 'constants/brand';
import { DialogHeading, DialogSection, DialogText } from '../../styles/DialogStyles';
import LittlewoodsBnplContent from '../littlewoods/BnplContent';
import VeryBnplContent from '../very/BnplContent';

interface Props {
  voucherCode: string;
  startDate: string;
  endDate: string;
  offerTerms1: string;
  offerTerms2?: string;
  offerTerms3?: string;
  offerTerms4?: string;
  site: SiteName;
}

function CreditToAccountContent(props: Props) {
  const { voucherCode, startDate, endDate, offerTerms1, offerTerms2, offerTerms3, offerTerms4, site } = props;
  const isLittlewoods = site === BrandTypes.LITTLEWOODS;
  const offerRange = getEndAndStartDate(startDate, endDate);
  const offerTerms4Text =
    offerTerms4 || 'Order must be placed online. If you return your item, the credit will be reversed.';

  return (
    <>
      <DialogSection>
        <DialogHeading data-testid="cta-dialog-offer-terms-1" size="1" tag="p" type="heading">
          1. {offerTerms1}
        </DialogHeading>

        {offerTerms2 && (
          <DialogHeading data-testid="cta-dialog-offer-terms-2" size="1" tag="p" type="heading">
            2. {offerTerms2}
          </DialogHeading>
        )}

        {offerTerms3 && (
          <DialogHeading data-testid="cta-dialog-offer-terms-3" size="1" tag="p" type="heading">
            3. {offerTerms3}
          </DialogHeading>
        )}

        <DialogText data-testid="cta-dialog-offer-terms-4" size="1" tag="p" type="paragraph">
          {offerTerms4Text}{' '}
          <strong>
            This can&apos;t be used in conjunction with other offers (entering any other promo code apart from{' '}
            {voucherCode} in checkout will exclude you from this promotion).{' '}
          </strong>
          Offer live {offerRange}
        </DialogText>
      </DialogSection>

      {isLittlewoods ? <LittlewoodsBnplContent /> : <VeryBnplContent />}
    </>
  );
}

export default CreditToAccountContent;
